import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useConfigs } from './lib/config-context';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const ShowMoreButton = ({
  columnData
}) => {
  const {
    cardsPerPage,
    onShowMore
  } = useConfigs();
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(LoadingButton, {
      loading: columnData.isLoadingMoreData,
      onClick: () => {
        if (typeof onShowMore === 'function' && cardsPerPage) {
          onShowMore(columnData, cardsPerPage);
        }
      },
      size: "small",
      use: "tertiary",
      marginBlockEnd: "300",
      marginBlockStart: "100",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customer-data-board.showMoreButton"
      })
    })
  });
};
export default ShowMoreButton;